var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.groupedPosts, function (group, index) {
        return _c("div", { key: index, staticClass: "note_analyst" }, [
          _c("div", {
            staticClass: "dateAnalyst",
            domProps: { innerHTML: _vm._s(group.dateGroup) },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row mt-4 row-cols-2" },
            _vm._l(group.posts, function (post, index2) {
              return _c(
                "div",
                { key: post.Id, staticClass: "col" },
                [_c("journalist-card", { attrs: { post: post, idx: index2 } })],
                1
              )
            }),
            0
          ),
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.enabled,
              expression: "enabled",
            },
          ],
          staticClass: "title-section analisisSect",
          on: { click: _vm.getPosts },
        },
        [_vm._m(0)]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "heading-title-sect text-center" }, [
      _c("span", [_vm._v("MÁS ANÁLISIS")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }